import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

const useFindOpportunitiesStyles = makeStyles(theme => ({
  main: {
    [theme.breakpoints.down('lg')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(4),
    },
  },
  searchBar: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '24px 20px',
    border: 'solid 1px #D3D9E0',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    flexWrap: 'wrap',
  },
  mainFiltersRow: {
    display: 'flex',
    gap: '9px',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  secondaryFiltersRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  pillFilters: {
    display: 'flex',
    gap: '9px',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  clearButton: {
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(2),
    },
  },
  locationElement: {
    flexGrow: 2,
  },
  resultsHeader: {
    display: 'flex',
    gap: '8px',
    marginTop: theme.spacing(2),
  },
  results: {
    marginTop: theme.spacing(2),
  },
  numberBackground: {
    backgroundColor: brandColors.coolGray3,
    borderRadius: '44px',
    width: '31px',
    height: '24px',
    textAlign: 'center',
    gap: '8px',
  },
  multiselect: {
    height: '48px',
  },
  pagination: {
    textAlign: 'center',
    marginTop: '20px',
    marginBottom: '20px',
  },
  mobileLane: {
    marginBottom: '20px',
  },
  emptyState: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
}))

export { useFindOpportunitiesStyles }
